/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskV2Dto } from './taskV2Dto';
import { SortPropertyDto } from './sortPropertyDto';

export interface PageDtoTaskV2Dto {
  content?: Array<TaskV2Dto>;
  firstPage?: boolean;
  lastPage?: boolean;
  nextPage?: boolean;
  number?: number;
  numberOfElements?: number;
  previousPage?: boolean;
  size?: number;
  sort?: Array<SortPropertyDto>;
  totalElements?: number;
  totalPages?: number;
}
